module.exports = __webpack_public_path__ + "static/img/7.bbc887e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/21/zh/7.png
// module id = 58y9
// module chunks = 0